<div class="schematic-overlay" (click)="onOverlayClick($event)" (wheel)="onOverlayWheel($event)">
  <div class="schematic-modal">
    <lib-gojs-schematic [substationId]="substationId" [substationName]="substationName" (closeSchematic)="onClose()"></lib-gojs-schematic>
  </div>
</div>
